import React from 'react';
import PartiesForm from './PartiesForm';
import { useParams } from 'react-router-dom';

const EditPartyPage = () => {
  const { id } = useParams();

  return (
    <>
     {id ? <PartiesForm formType='edit' currentPartyId={id} /> : 'Loading...'}
    </>
  );
};

export default EditPartyPage;